





















import { Component, Prop, Vue, Inject } from 'vue-property-decorator';

import {
  type ILogger,
  type ITopArticlesBlockUseCase,
  LOGGER_KEY,
  PageStoreFacade,
  PAGE_STORE_FACADE_KEY,
  TopArticlesBlockUseCase,
  type TopArticlesBlockVM,
  guardTopArticlesBlockNotLazy,
} from '@jtnews/shared/seedwork/frontend/application';
import {
  type BlockPlaceRepositoryConfig,
  type IBlockPlaceRepository,
  type IReachGoalAnalytics,
  REACH_GOAL_ANALYTICS_KEY,
  TopArticlesBlockAnalyticsService,
} from '@jtnews/shared/seedwork/frontend/domain';
import {
  BLOCK_TYPE_REPOSITORY_KEY,
  type IAppNewsClient,
  NEWS_CLIENT_KEY,
  TopArticlesBlockApi,
  TopArticlesLazyBlockPresenter,
} from '@jtnews/shared/seedwork/frontend/infrastructure';
import { UiBaseBlock } from '@jtnews/shared/ui';

import { TopArticlesItem } from './top-articles-item';

@Component({
  components: {
    UiBaseBlock,
    TopArticlesItem,
  },
  name: 'TopArticlesBlock',
})
export default class TopArticlesBlock extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  block!: TopArticlesBlockVM;

  @Prop({
    required: true,
    type: Object as () => BlockPlaceRepositoryConfig,
  })
  blockPlaceConfig!: BlockPlaceRepositoryConfig;

  @Inject(LOGGER_KEY)
  logger!: ILogger;

  @Inject(NEWS_CLIENT_KEY)
  newsClient!: IAppNewsClient;

  @Inject(REACH_GOAL_ANALYTICS_KEY)
  reachGoalAnalytics!: IReachGoalAnalytics;

  @Inject(BLOCK_TYPE_REPOSITORY_KEY)
  blockPlaceRepository!: IBlockPlaceRepository;

  @Inject(PAGE_STORE_FACADE_KEY)
  pageStoreFacade!: PageStoreFacade;

  useCase: ITopArticlesBlockUseCase = new TopArticlesBlockUseCase({
    regionId: this.pageStoreFacade.regionId,
    deps: {
      analyticsService: new TopArticlesBlockAnalyticsService({
        pageName: this.pageStoreFacade.pageName,
        deps: {
          blockPlaceRepository: this.blockPlaceRepository,
          analytics: this.reachGoalAnalytics,
        },
      }),
      getBlock: new TopArticlesBlockApi({
        deps: {
          client: this.newsClient,
        },
      }),
      presenter: new TopArticlesLazyBlockPresenter({
        deps: {
          logger: this.logger,
        },
      }),
      store: this.pageStoreFacade,
      logger: this.logger,
    },
  });

  get params() {
    return guardTopArticlesBlockNotLazy(this.block) ? this.block.params : { title: '' };
  }

  get items() {
    return guardTopArticlesBlockNotLazy(this.block) ? this.block.data : [];
  }

  created() {
    this.useCase.setBlockPlace(this.blockPlaceConfig);
  }

  processLazyLoad() {
    void this.useCase.getBlock();
  }

  processBlockShown() {
    this.useCase.processBlockShown(this.items);
  }

  processArticleClick({ articleId }: { articleId: number }) {
    this.useCase.processArticleClick(articleId);
  }

  processCommentClick(event: { event: Event; articleId: number }): void {
    this.useCase.processCommentClick(event);
  }
}
